import api from "./axios";
import type { TicketType } from "@/struct/FeedbackStruct";

export const sendTicket = async (data: TicketType) => {
  return await api.post("/api/web-api/integration/otrs/send-ticket", {
    ticket_subject: data.ticket_subject,
    phone_model: data.phone_model,
    customer_msisdn: data.customer_msisdn,
    customer_email: data.customer_email,
    ticket_body: data.ticket_body,
    attachments: data.attachments,
  });
};
